export const BpmStatus = {
  OFF_BODY: 'OFF_BODY',
  READING: 'READING',
  DANGER: 'DANGER',
  WARNING: 'WARNING',
  NORMAL: 'NORMAL',
};